import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Pencil, Users, Send } from "lucide-react";

const icons = [Pencil, Users, Send];

const HowItWorks = () => {
  const { t } = useTranslation();
  const steps = t("howItWorks.steps", { returnObjects: true }) as { title: string; description: string }[];

  return (
    <section id="how-it-works" className="py-28 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-24"
        >
          <h2 className="text-3xl md:text-5xl font-extralight text-foreground tracking-tight">
            {t("howItWorks.title")}
          </h2>
          <p className="mt-6 text-muted-foreground max-w-xl mx-auto text-base font-light">
            {t("howItWorks.subtitle")}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-16 max-w-4xl mx-auto">
          {steps.map((step, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15 }}
                className="text-center"
              >
                <div className="mx-auto w-16 h-16 rounded-full border border-border flex items-center justify-center mb-8">
                  <Icon size={22} strokeWidth={1.2} className="text-foreground" />
                </div>
                <span className="text-[10px] font-light text-muted-foreground uppercase tracking-[0.25em]">
                  {t("howItWorks.step")} {i + 1}
                </span>
                <h3 className="text-lg font-light text-foreground mt-3 mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm font-light leading-relaxed">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
